<template>
  <section class="banner__area pt-60 pb-25">
    <div class="container">
      <div class="row">
        <!-- First Column -->
        <div class="col-xl-4 col-lg-6 col-md-12" v-if="adsByType[6]">
          <div class="banner__item p-relative w-img mb-30">
            <div class="banner__img">
              <router-link to="/shop">
                <img :src="adsByType[6].image_url" :alt="adsByType[6].title" />
              </router-link>
            </div>
            <div class="banner__content banner__content-sd text-center">
              <div class="banner-button mb-20">
                <router-link to="/shop" class="st-btn">{{ adsByType[6].tag }}</router-link>
              </div>
              <h6>
                <router-link to="/shop">
                  {{ adsByType[6].title }} <br />
                  {{ adsByType[6].text }}
                </router-link>
              </h6>
            </div>
          </div>
        </div>

        <!-- Second Column -->
        <div class="col-xl-4 col-lg-6 col-md-12" v-if="adsByType[7]">
          <div class="row">
            <!-- Top Item -->
            <div class="col-md-12">
              <div class="banner__item p-relative mb-30 w-img">
                <div class="banner__img">
                  <router-link to="/shop">
                    <img :src="adsByType[7].image_url" :alt="adsByType[7].title" />
                  </router-link>
                </div>
                <div class="banner__content banner__content-sd text-center">
                  <h6><router-link to="/shop">{{ adsByType[7].title }} </router-link></h6>
                  <p>{{ adsByType[7].text }}</p>
                  <div class="banner-button mt-20 d-none d-sm-block">
                    <router-link to="/shop" class="st-btn-3 b-radius">{{ adsByType[7].tag }}</router-link>
                  </div>
                </div>
              </div>
            </div>

            <!-- Bottom Item -->
            <div class="col-md-12" v-if="adsByType[8]">
              <div class="banner__item p-relative w-img mb-30">
                <div class="banner__img">
                  <router-link to="/shop">
                    <img :src="adsByType[8].image_url" :alt="adsByType[8].title" />
                  </router-link>
                </div>
                <div class="banner__content">
                  <h6>
                    <router-link to="/shop">
                      {{ adsByType[8].title }}
                    </router-link>
                  </h6>
                  <p>{{ adsByType[8].text }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Third Column -->
        <div class="col-xl-4 col-lg-6 col-md-12" v-if="adsByType[9]">
          <div class="banner__item p-relative mb-30 w-img">
            <div class="banner__img">
              <router-link to="/shop">
                <img :src="adsByType[9].image_url" :alt="adsByType[9].title" />
              </router-link>
            </div>
            <div class="banner__content banner__content-sd text-center">
              <div class="banner-button mb-20">
                <router-link to="/shop" class="st-btn">{{ adsByType[9].tag }}</router-link>
              </div>
              <h6>
                <router-link to="/shop">
                  {{ adsByType[9].title }} <br />
                  {{ adsByType[9].text }}
                </router-link>
              </h6>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  
</template>

<script>
export default {
  props: {
    ads: {
      type: Array,
      required: true,
    },

  },
  computed: {
    adsByType() {
      // Group ads by their add_type
      const groupedAds = {};
      this.ads.forEach(ad => {
        if ([6, 7, 8, 9].includes(ad.add_type)) {
          groupedAds[ad.add_type] = ad;
        }
      });
      return groupedAds;
    },
  },
  mounted() {

    console.log("Ads received in ProductBannerAreaThree:", this.ads)
  },

};
</script>

<style scoped>
/* Add styles here, if needed */
</style>